import { useEffect } from 'react'

const TechListPreviewMobile = props => {
  const { data, loading, close, download, printRef } = props

  useEffect(() => {
    if (!loading && printRef.current) {
      download(printRef, data?.slug)
        .then(() => new Promise(resolve => setTimeout(resolve, 1000)))
        .then(close)
    }
  }, [loading, printRef])

  return null
}

export default TechListPreviewMobile
